// extracted by mini-css-extract-plugin
export default {"cardClass":"ResetPassword_cardClass__sN9ig","control":"ResetPassword_control__VZo4X","action":"ResetPassword_action__k0V8g","btn":"ResetPassword_btn__FOPLZ"};